export const promoCont = {
  display: "flex",
  width: "100%",
  height: "calc(100vh - 72px)",
}
